/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Faq_1_AInputs */

const en_cp_faq_1_a = /** @type {(inputs: Cp_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep does not write the students' application code. It forces students to write pass/fail criteria, run verification, and upload evidence before a task can be done — exactly the design research recommends so AI is a scaffold, not a substitute for thinking. Strict mode disables overrides for theses.`)
};

const id_cp_faq_1_a = /** @type {(inputs: Cp_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep tidak menulis kode aplikasi mahasiswa. Ia memaksa mahasiswa menulis kriteria lulus/gagal, menjalankan verifikasi, dan mengunggah bukti sebelum task boleh selesai — persis desain yang direkomendasikan riset agar AI jadi scaffold, bukan pengganti berpikir. Mode Strict mematikan override untuk skripsi.`)
};

/**
* | output |
* | --- |
* | "Bystep does not write the students' application code. It forces students to write pass/fail criteria, run verification, and upload evidence before a task can..." |
*
* @param {Cp_Faq_1_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_faq_1_a = /** @type {((inputs?: Cp_Faq_1_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Faq_1_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_faq_1_a(inputs)
	return en_cp_faq_1_a(inputs)
});